import { Dispatch } from 'react';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import getFlagValue from '../../utils/getFlagValue';
import {
  addQueuePackageServiceCount,
  resetQueuePackageServiceCount,
} from '../../../store/emarsys/action';
import { PAGE_NAME_SERVICE_PACKAGE } from '../../../constants/emarsys/service-package';

export default function eventClickPackageServiceList(
  dispatch: Dispatch<any>,
  carCategory: string,
  pageTitle: string = '',
  breadcrumbItems: IBreadcrumbs[],
  customerNo: string,
  sectionName: string,
  buttonName: string,
  carModel?: string[],
  newParams?: Record<string, string | number | boolean>
) {
  const isFlagActive = getFlagValue('EMARSYS');
  if (!isFlagActive) return;

  if (customerNo) {
    ScarabQueue.push(['setCustomerId', customerNo]);
  }

  const valueClickAction: Record<string, string | number | boolean> = {
    page_name: PAGE_NAME_SERVICE_PACKAGE.SERVICE_PACKAGE_LISTING_PAGE,
    page_title: pageTitle,
    page_url: window.location.href,
    section_name: sectionName,
    button_name: buttonName,
  };

  if (breadcrumbItems?.[1]?.name) {
    valueClickAction.menu_cat_lvl1 = breadcrumbItems?.[1]?.name?.toLowerCase();
  }

  if (breadcrumbItems?.[2]?.name) {
    valueClickAction.menu_cat_lvl2 = breadcrumbItems?.[2]?.name?.toLowerCase();
  }

  if (breadcrumbItems?.[3]?.name) {
    valueClickAction.menu_cat_lvl3 = breadcrumbItems?.[3]?.name?.toLowerCase();
    valueClickAction.car_category = breadcrumbItems?.[3]?.name?.toLowerCase();
  }

  if (carModel && carModel.length > 0) {
    valueClickAction.car_model = carModel.join(',');
  }

  if (carCategory) {
    valueClickAction.car_category = carCategory.toLowerCase();
  }

  if (newParams?.car_model) {
    valueClickAction.car_model = newParams?.car_model;
  }
  if (newParams?.order_by) {
    valueClickAction.order_by = newParams?.order_by;
  }
  if (newParams?.search) {
    valueClickAction.search = newParams?.search;
  }
  if (newParams?.special_offer) {
    valueClickAction.special_offer = newParams?.special_offer;
  }

  ScarabQueue.push(['tag', 'click_button', valueClickAction]);
  if (buttonName.includes('lihat semua')) {
    ScarabQueue.push(['go']);
    dispatch(resetQueuePackageServiceCount());
  } else {
    dispatch(addQueuePackageServiceCount());
  }
}
